// extracted by mini-css-extract-plugin
module.exports = {"selects":"CurrentMedConditions_selects__-0j24"};